<template>
  <b-navbar toggleable="md" class="shadow" variant="dark" type="dark" sticky>
    <b-navbar-toggle target="menu" />
    <b-collapse is-nav id="menu">
      <b-navbar-nav>
        <b-nav-item to="/dashboard" hidden>Dashboard</b-nav-item>
        <b-nav-item v-if="isUserRole(roles.ADMINISTRATOR)" to="/requests"
          >Anfragen
        </b-nav-item>
        <b-nav-item v-if="isUserRole(roles.ADMINISTRATOR)" to="/users"
          >Benutzer
        </b-nav-item>
        <!--        <b-nav-item v-if="isUserRole(roles.ADMINISTRATOR)" to="/reports"-->
        <!--          >Berichte-->
        <!--        </b-nav-item>-->
        <b-nav-item v-if="isUserRole(roles.DELIVERY_NURSE)" to="/requests"
          >Meine Anfragen
        </b-nav-item>
        <b-nav-item v-if="isUserRole(roles.DELIVERY_NURSE)" to="/open-requests"
          >Offene Anfragen
        </b-nav-item>
        <b-nav-item v-if="isUserRole(roles.DELIVERY_NURSE)" to="/my-services"
          >Meine Dienstleistungen
        </b-nav-item>
        <b-nav-item @click="logout()">Ausloggen</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { authMixin } from "../mixins/auth";

export default {
  name: "Navbar",
  mixins: [authMixin]
};
</script>

<style scoped>
nav {
  margin-bottom: 30px;
}
</style>
